import {
  MASK_CUSTOM_FOOTER_STATE,
  SET_IS_SHOWING_COMPATIBLE_THEMES
} from '../action_types.js';

export default (state = {}, action)=> {

  switch (action.type) {

  case 'SET_THEMES':
    return { 
      ...state,
      themes: action.themes
    };

  case 'SET_LOADING_THEMES':
    return {
      ...state,
      isLoadingThemes: action.value
    };

  case 'SET_CURRENT_THEME': {
    return {
      ...state,
      id: action.id,
      uuid: action.uuid,
      customFooterHtml: action.customFooterHtml,
      useFixedNavLinks: action.useFixedNavLinks,
      stylePresets: action.stylePresets,
      canShowActionIcons: action.canShowActionIcons,
      stylesheetVersion: action.stylesheetVersion,
      mostCommonFontColors: action.mostCommonFontColors,
      mostCommonBackgroundColors: action.mostCommonBackgroundColors
    };
  }

  case MASK_CUSTOM_FOOTER_STATE: {
    return {
      ...state,
      customFooterHtml: action.customFooterHtml
    };
  }

  case SET_IS_SHOWING_COMPATIBLE_THEMES:
    return {
      ...state,
      isShowingCompatibleThemes: action.isShowingCompatibleThemes
    };

  default: {
    return state;
  }

  }

};

// See `zoomforth_codesbane_viewer/reducers/theme.selectors.js` for
// viewer-specific theme selectors about the currently selected theme.


export const getThemes = (state)=>
  state.themes;

export const getIsLoadingThemes = (state)=>
  !!state.isLoadingThemes;

export const getIsShowingCompatibleThemes = (state)=>
  !!state.isShowingCompatibleThemes;
